"use client";
import { TextGenerateEffect } from "@/components/ui/text-generate-effect";
import { TextGenerateEffectBigger } from "@/components/ui/text-generate-effect-Bigger";
const words = `Tapio Meriläinen`;
const bigWords = 'Portfolio';

export function TextGenerateEffectDemo() {
  return (
      <div className="content-center text-center text-4xl sticky pt-32 z-50">
          <TextGenerateEffect words={words}/>
          <TextGenerateEffectBigger words={bigWords}/>
       </div>);}
